import { render } from "./Loading.vue?vue&type=template&id=4fed3804&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=4fed3804&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\sistema-denuncias\\public\\apps\\presos-politicos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fed3804"]])

export default __exports__